import { Record } from 'immutable';
export class PhoneNumberIdentifier extends Record({
  objectTypeId: null,
  objectId: null,
  propertyName: null
}, 'PhoneNumberIdentifier') {
  toKey() {
    return `${this.objectTypeId}_${this.objectId}_${this.propertyName}`;
  }
}